import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { FILTER_OPERATOR_LABELS, RELEVANT_NUMBER_OPERATORS } from '@shared/constants/dataGrid'

import { QuestionGroupsColumnType } from '../questionGroupsDataGridColumns'

export const questionCountColumnModel: QuestionGroupsColumnType = {
  field: 'questionCount',
  width: 100,
  filterOperators: getGridNumericOperators().filter((operator) =>
    Object.keys(RELEVANT_NUMBER_OPERATORS).includes(operator.value)).map((operator) => ({
    ...operator,
    type: 'number',
    label: FILTER_OPERATOR_LABELS[operator.value as keyof typeof FILTER_OPERATOR_LABELS]
  })),
  type: 'number',
  align: 'left',
  headerAlign: 'left'
}
